import React from 'react';
import searchPageHelper from 'shared/routes/search';
import { setTargetingArguments, setLocation } from 'shared/actions/globals';
import { urlReplaceSlash } from 'shared/modules';
import { clearSelected } from 'shared/actions/searchForm';
import Layout from 'desktop/components/Layout/Layout';
import LINKS from 'desktop/constants/navigation';
import { isCanBeRedirected, fetchVipCars } from 'shared/helpers/search';
import Search from './Search';

async function action(params) {
  const { store, fetch } = params;
  let specialCars = null;
  const pageParams = await searchPageHelper(params);

  if (!pageParams) {
    return null;
  }

  // REDIRECT FUNCTIONALITY
  // delete last query param if count === false and redirect
  if (!pageParams.count && isCanBeRedirected(pageParams)) {
    // first - clear location param from store if we have it
    const state = store.getState();
    const {
      globals: { location = '' },
    } = state;
    let redirectUrl = '/';

    if (location) store.dispatch(setLocation(null));

    // after - delete last query param from url
    if (pageParams.url) {
      const urlArr = pageParams.url.split('/').filter(item => item);
      urlArr.pop();
      redirectUrl = `/${urlArr.join('/')}/`;
    }
    store.dispatch(clearSelected());

    return {
      status: 302,
      redirect: urlReplaceSlash(redirectUrl),
    };
  } else if (!pageParams.count) {
    specialCars = await fetchVipCars(fetch);
  }

  const {
    url,
    seoQuery,
    transportType,
    currentPage,
    carsListTypes,
    currency,
    title,
    description,
    metaHeader,
    targetingArguments,
    isLastPage,
    isMotoSearch,
    isCommercial,
    canonicalList,
    shouldSetNoIndex,
    shouldSetIndex,
    location,
    q: fullQuery,
    characteristics,
    carsResult,
  } = pageParams;

  store.dispatch(setTargetingArguments(targetingArguments));

  return {
    chunks: ['search'],
    title,
    description,
    page: currentPage,
    isLastPage,
    routeName: 'search',
    shouldSetNoIndex,
    shouldSetIndex,
    component: (
      <Layout withBranding navLinks={LINKS.SEARCH[transportType.slug]} currentRoute={url}>
        <Search
          carsResult={carsResult}
          fullQuery={fullQuery}
          isMotoSearch={isMotoSearch}
          isCommercial={isCommercial}
          transportType={transportType}
          carsListTypes={carsListTypes}
          currentPage={currentPage}
          currency={currency}
          url={url}
          query={seoQuery}
          canonicalList={canonicalList}
          pageQuery={params.query}
          location={location}
          title={metaHeader}
          seoCharacteristics={characteristics}
          specialCars={specialCars}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/search/index.js